import { Field, Label, Switch } from '@headlessui/react'
import clsx from 'clsx'

type Props = {
    loading: boolean
    checked: boolean
    onToggle: (isEnabled: boolean) => Promise<void>
    label: string
    subtitle?: string
    tooltip: string
    disabled: boolean
    id: string
}

/**
 * A toggle switch with a label, subtitle, and tooltip.
 *
 * From https://tailwindui.com/components/application-ui/forms/toggles
 */
const DescriptiveToggle = (props: Props) => {
    const { checked, onToggle, label, subtitle, tooltip, disabled, id, loading } = props

    return (
        <div
            key={id}
            data-tooltip-content={tooltip}
            data-tooltip-id="tooltip-id"
            className={clsx('flex items-center justify-between', disabled && 'opacity-50')}
        >
            <Field className="flex">
                <Switch
                    disabled={disabled || loading}
                    checked={checked}
                    onChange={onToggle}
                    className="group relative inline-flex h-6 w-[44px] min-w-[44px] cursor-pointer items-center rounded-full bg-gray-200 p-1 transition-colors data-[checked]:bg-primary-600 "
                >
                    <span className="absolute top-0.5 left-0.5 inline-block w-5 h-5  translate-x-0 rounded-full bg-white shadow transition-transform group-data-[checked]:translate-x-5" />
                </Switch>
                <Label className="ml-3 flex flex-col text-sm leading-5 text-gray-700">
                    <span className="font-semibold text-gray-900">{label}</span>
                    {subtitle && <span className="text-gray-600">{subtitle}</span>}
                </Label>
            </Field>
        </div>
    )
}

export default DescriptiveToggle
